module.exports = __webpack_public_path__ + "img/mdm-deploy-1.a475a29d.jpg";